import React from "react";
import { ArrowRight, MapPin } from "lucide-react";
import { HERO } from "@/constants/testIds";

const HERO_BG =
  "https://images.unsplash.com/photo-1611174797197-8533987c6bf4?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400";

export default function Hero() {
  const goto = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="top"
      data-testid={HERO.section}
      className="relative min-h-[92vh] flex items-end overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="Aerial Country — waterways, wetlands and forest"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bm-hero-overlay" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 pb-20 pt-32 w-full">
        <div className="max-w-4xl bm-rise">
          <div className="flex items-center gap-3 mb-6 text-white/85">
            <div className="h-px w-10 bg-white/60" />
            <span className="text-[11px] tracking-[0.28em] uppercase">
              Interactive Knowledge Systems
            </span>
          </div>
          <h1
            data-testid={HERO.title}
            className="font-serif-display text-white text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight"
          >
            Visualising Country.<br />
            <span className="italic text-[#E9C7A8]">Sharing Knowledge.</span><br />
            Supporting Caring for Country.
          </h1>

          <p
            data-testid={HERO.subtitle}
            className="mt-8 text-white/85 text-lg sm:text-xl max-w-2xl leading-relaxed font-light"
          >
            Illustrated knowledge maps developed with Traditional Owners to
            document plants, animals, landscapes, cultural values, seasonal
            knowledge and Caring for Country priorities.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <button
              data-testid={HERO.viewMaps}
              onClick={() => goto("examples")}
              className="bm-btn-secondary"
            >
              <MapPin size={16} /> View Example Maps
            </button>
            <button
              data-testid={HERO.startProject}
              onClick={() => goto("contact")}
              className="bm-btn-primary"
            >
              Start a Project <ArrowRight size={16} />
            </button>
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-6 right-6 lg:right-12 hidden md:flex flex-col items-center text-white/70 text-[11px] tracking-[0.3em] uppercase">
        <span className="mb-3 rotate-90 origin-center">Scroll</span>
        <div className="w-px h-12 bg-white/40" />
      </div>
    </section>
  );
}
